/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { Anchor } from "hesus-ui-kit";
import {
  DivBackgroundLowOpacity,
  DivBackgroundFullOpacity,
} from "../../RelatedContactList.styled";

const CompanyLink = (props) => {
  const { t, data } = props;

  return (
    <>
      {!!data.status && data.id !== "" && (
        <DivBackgroundFullOpacity>
          <Anchor
            target="_blank"
            rel="noreferrer"
            url={`/company/view/${data.id}/general-info`}
          >
            {data.name}
          </Anchor>
        </DivBackgroundFullOpacity>
      )}
      {!data.status && data.id !== "" && (
        <DivBackgroundLowOpacity>
          <Anchor
            target="_blank"
            rel="noreferrer"
            url={`/company/view/${data.id}`}
          >
            {data.name}
          </Anchor>
        </DivBackgroundLowOpacity>
      )}
      {!!data.status && data.id === "" && (
        <DivBackgroundFullOpacity>{t(data.name)}</DivBackgroundFullOpacity>
      )}
      {!data.status && data.id === "" && (
        <DivBackgroundLowOpacity>{t(data.name)}</DivBackgroundLowOpacity>
      )}
    </>
  );
};

CompanyLink.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(CompanyLink);
